import { TableTypesEnum } from './useTypeOptions';

type TagColorType = {
  [key: string]: string;
};

export const useTagColor = (type: string) => {
  const colorfulTags: TagColorType = {
    [TableTypesEnum.Main]: 'blue',
    [TableTypesEnum.Summary]: 'green',
  };

  return colorfulTags[type] ?? 'default';
};
